import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-291e9134"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "lang-tabs" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "abbr" }, "En", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "영어", -1))
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "abbr" }, "Kr", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "한국어", -1))
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "abbr" }, "Ru", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "러시아어", -1))
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]

import { ref } from 'vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'LangTabs',
  props: {
  context: {
    type: String,
    required: false,
  },
},
  emits: ['onClick_langOption'],
  setup(__props, { emit }) {

const props = __props;



/**** data -------------------- */
var isOn_tabEn = ref(true);
var isOn_tabKr = ref(false);
var isOn_tabRu = ref(false);
/**** methods ----------------- */
const resetTabs = () => {
  isOn_tabEn.value = false;
  isOn_tabKr.value = false;
  isOn_tabRu.value = false;
};
const onClick_tabs = async (lang: string) => {
  await resetTabs();
  if (lang === 'en') {
    isOn_tabEn.value = true;
    emit('onClick_langOption', lang);
  } else if (lang === 'kr') {
    isOn_tabKr.value = true;
    emit('onClick_langOption', lang);
  } else if (lang === 'ru') {
    isOn_tabRu.value = true;
    emit('onClick_langOption', lang);
  }
};
/**** content -----------------
 *
 * 다국어 선택: 영어 / 한국어 / 러시아어
 * /
 * /
/**** hook -------------------- */

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: _normalizeClass(["lang-tab-en", [{ on: _unref(isOn_tabEn) }]]),
      onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (onClick_tabs('en')), ["prevent"]))
    }, _hoisted_4, 2),
    _createElementVNode("button", {
      class: _normalizeClass(["lang-tab-kr", [{ on: _unref(isOn_tabKr) }]]),
      onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (onClick_tabs('kr')), ["prevent"]))
    }, _hoisted_7, 2),
    _createElementVNode("button", {
      class: _normalizeClass(["lang-tab-ru", [{ on: _unref(isOn_tabRu) }]]),
      onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (onClick_tabs('ru')), ["prevent"]))
    }, _hoisted_10, 2)
  ]))
}
}

})